import goTo from './goTo'
import cmbcFun from '../appapi/cmbc/cmbcFun'
import { isAndroid, isBohaiApp, isWechat } from './ua'
import { getStorage } from './onStorage'
import { pay } from '../services/pay'
import { Toast } from 'antd-mobile'
import React from 'react'
import { trackEvent } from '@/libs/functions/track'
import { addParameters } from './tools'
import { sendNativeCmd } from '../appapi/quanzhou/nativeTsBridge'
import { wxMiniUrlPrefixReplace } from './utils'


/**
 * @desc adapter 适配不同的app里返回webview跳转、隐藏导航栏等等方法
 */
export default function getChannelBridgeApi(channel: string): {
  hideNavBar: () => void
  goBackWebview: () => void
  hideLayoutNavBar: () => boolean
  initApi?: () => void // api初始化
  setNavBar?: (title: string) => void // 设置导航栏
  goToOrderList?: () => void
  goToPay?: (params: Record<string, any>) => void
  goToPayWithParams?: (params: Record<string, any>) => void
  goToPayResult?: (params: Record<string, any>) => void
  goToCodeExchangeSucceed?: () => void
  goToLogin?: (params: Record<string, any>) => void
  disablePayListSelect?: () => boolean // 是否隐藏支付方式选择
  goToThirdWxMiniProgram?: (params: {
    url: string
  }) => void
  downloadPdf?: (downloadUrl: string, previewUrl: string) => void
} {
  const wx = window?.wx || window?.proxy?.wx

  switch (channel) {
    case 'changan':
      return {
        hideNavBar() {
          console.log('call hideNavBar')
          if (isAndroid) {
            try {
              window?.control?.onHideBar?.('1')
            } catch (e) {
              console.log('andriod error')
            }
          } else {
            try {
              window?.webkit?.messageHandlers?.hiddenNavigationBar?.postMessage?.(
                '',
              )
            } catch (e) {
              console.log('ios error')
            }
          }
        },
        goBackWebview() {
          console.log('call goBack')
          if (isAndroid) {
            try {
              window?.control?.goBack?.()
            } catch (error) {
              console.log('andriod error')
            }
          } else {
            try {
              window?.webkit?.messageHandlers?.goBack?.postMessage('')
            } catch (error) {
              console.log('ios error')
            }
          }
        },
        hideLayoutNavBar: () => false,
      }
    // 上海银行
    case 'bosc':
      return {
        hideNavBar() { },
        goBackWebview() {
          console.log('call bosc goBack')
          try {
            window?.AlipayJSBridge?.call(
              'back',
              {
                index: 1,
              },
              () => { },
            )
          } catch (e) {
            console.log('ios error')
          }
        },
        hideLayoutNavBar: () => false,
      }
    // 渤海
    case 'bohai':
      return {
        hideNavBar() { },
        goBackWebview() {
          goTo(-1)
        },
        hideLayoutNavBar: () => {
          if (isBohaiApp) return true
          if (isWechat) return false
          return false
        },
      }
    // 邮储
    case 'youchu':
      return {
        hideNavBar() { },
        goBackWebview() {
          console.log('call youchu goBack')
          try {
            window?.AlipayJSBridge.call(
              'popWindow',
              null,
              function (result: unknown) {
                console.log('call youchu goBack: ', result)
              },
            )
          } catch (e) {
            console.log('ios error')
          }
        },
        hideLayoutNavBar: () => false,
      }
    // 中信
    case 'CITIC':
      return {
        hideNavBar() { },
        goBackWebview() { },
        hideLayoutNavBar: () => true,
      }
    // 民生
    case 'cmbc':
      return {
        hideNavBar() { },
        goBackWebview() {
          trackEvent('checkCMBCCloseViewBackEvent', {
            meta: {
              action: 'inBack',
              closeWebView: JSON.stringify(window?.CMBCJSBridge?.closeWebView),
            },
          })
          if (typeof window?.CMBCJSBridge?.closeWebView === 'function') {
            trackEvent('checkCMBCCloseViewSDKEvent', {
              meta: {
                action: 'function',
              },
            })
          } else {
            trackEvent('checkCMBCCloseViewSDKEvent', {
              meta: {
                action: 'undefined sdk',
              },
            })
          }
          try {
            window?.CMBCJSBridge?.closeWebView?.()
          } catch (error) {
            console.log('cmbc error', error)
            trackEvent('checkCMBCCloseViewErrorEvent', {
              meta: {
                action: 'errorBack',
                error: JSON.stringify(error),
              },
            })
          }
        },
        hideLayoutNavBar: () => true,
        initApi: () => {
          cmbcFun.initApi()
        },
        setNavBar: (title: string) => {
          cmbcFun.setNavBar(title)
        },
      }
    case 'drt':
      return {
        hideNavBar() { },
        goBackWebview() { },
        hideLayoutNavBar: () => true,
        goToOrderList: () => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.navigateTo({
                url: '/pages/orderList/orderList',
              })
            }
          })
        },
        goToPay: (params: Record<string, any>) => {
          window?.wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/pay/index/index?orderNo=${params.orderNo}`,
              })
            }
          })
        },
        goToPayResult: ({ status }) => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/pay/result/index?status=${status}`,
              })
            }
          })
        },
        downloadPdf(downloadPdf: string, previewUrl: string) {
          wx?.miniProgram.getEnv(function (res) {
            console.log('downloadPdf: ', downloadPdf, previewUrl)
            if (res.miniprogram) {
              window?.wx?.miniProgram.navigateTo({
                url: `/pages/pdfViewer/pdfViewer?downloadPdf=${downloadPdf || ''
                  }&previewUrl=${previewUrl || ''}`,
              })
            } else {
              window.open(downloadPdf, '__blank')
            }
          })
        },
      }
    case 'plus':
      return {
        hideNavBar() { },
        goBackWebview() { },
        hideLayoutNavBar: () => true,
        goToOrderList: () => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              window?.wx?.miniProgram.switchTab({
                url: '/pages/main/userOrder/userOrder',
              })
            }
          })
        },
        goToPay: (params: Record<string, any>) => {
          window?.wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/pay/index/index?orderNo=${params.orderNo}`,
              })
            }
          })
        },
        goToPayResult: ({ status }) => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/pay/result/index?status=${status}`,
              })
            }
          })
        },
        goToLogin: ({ redirectUrl }) => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/login/login?redirectType=h5&redirectUrl=${redirectUrl}`,
              })
            }
          })
        },
      }
    // 权益通小程序
    case 'qyt':
      return {
        hideNavBar() { },
        goBackWebview() { },
        hideLayoutNavBar: () => true,
        goToOrderList: () => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              window?.wx?.miniProgram.switchTab({
                url: '/pages/main/userOrder/userOrder',
              })
            }
          })
        },
        goToPay: (params: Record<string, any>) => {
          window?.wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/pay/index/index?orderNo=${params.orderNo}`,
              })
            }
          })
        },
        goToPayResult: ({ status }) => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/pay/result/index?status=${status}`,
                success: () => {
                  return true
                },
                fail: () => {
                  return false
                },
              })
            } else {
              return false
            }
          })
        },
        // 兑换码兑换成功页
        goToCodeExchangeSucceed() {
          const tenantCode = getStorage('tenantCode') || ''
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/codeExchangeSucceed/codeExchangeSucceed?tenantCode=${tenantCode}`,
              })
            }
          })
        },
        goToThirdWxMiniProgram(params: {
          url: string;
        }) {
          if (!params.url) {
            console.log('[Function goToThirdWxMiniProgram] params.url is empty')
            return
          }
          const afterUrl = wxMiniUrlPrefixReplace(params.url, '/pages/midToMiniProgram/midToMiniProgram')
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              window?.wx?.miniProgram.navigateTo({
                url: afterUrl,
              })
            }
          })
        },
        downloadPdf(downloadPdf: string, previewUrl: string) {
          try {
            wx?.miniProgram.getEnv(function (res) {
              console.log('downloadPdf: ', downloadPdf, previewUrl)
              if (res.miniprogram) {
                window?.wx?.miniProgram.navigateTo({
                  url: `/pages/pdfViewer/pdfViewer?downloadPdf=${downloadPdf || ''
                    }&previewUrl=${previewUrl || ''}`,
                })
              } else {
                window.open(downloadPdf, '__blank')
              }
            })
          }
          catch (err) { }
        },
      }

    // 钉钉企服小程序
    case 'ding':
      return {
        hideNavBar() { },
        goBackWebview() { },
        hideLayoutNavBar: () => true,
        goToOrderList: () => {
          try {
            window?.dd?.switchTab({
              url: '/pages/orderList/orderList',
            })
          } catch (error) {
            console.log(error)
          }
        },
        goToPay: (params: Record<string, any>) => {
          try {
            window?.dd.redirectTo({
              url: `/pages/pay/index/index?orderNo=${params.orderNo}`,
            })
          } catch (err) {
            console.log(err)
          }
        },
        goToPayResult: ({ status }) => {
          try {
            window?.dd.redirectTo({
              url: `/pages/pay/result/index?status=${status}`,
              success: () => {
                return true
              },
              fail: () => {
                return false
              },
            })
          } catch (err) {
            console.log(err)
          }
        },
      }
    // 会员小程序
    case 'member_mini':
      return {
        hideNavBar() { },
        goBackWebview() { },
        hideLayoutNavBar: () => true,
        goToOrderList: () => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              window?.wx?.miniProgram.navigateTo({
                url: '/packages/order/list/index',
              })
            }
          })
        },
        // 带上支付参数：跳转第三方支付thirdPay，经过收银台，最后由/miniprogramPay 中间页进行分发
        goToPayWithParams: (params: Record<string, any>) => {
          const query = Object.fromEntries(
            Object.entries(params || {}).map(([key, val]) => [
              key,
              String(val ?? ''),
            ]),
          )
          const url = addParameters('/packages/saas/pay/index', query)
          console.log('goTopayUrl:', url)
          wx?.miniProgram.getEnv(function (res: Record<string, any>) {
            if (res.miniprogram) {
              window?.wx?.miniProgram.navigateTo({
                url,
                fail(err) {
                  console.log('goToPay err:', err)
                }
              })
            }
          })
        },
        disablePayListSelect: () => true,
        goToLogin: ({ redirectUrl }) => {
          // 是否需要显示非微信提示
          let shouldShowWechatEnvToast = true
          wx?.miniProgram.getEnv(function (res) {
            console.log('getEnv:', res)
            if (res.miniprogram) {
              shouldShowWechatEnvToast = false
              window?.wx?.miniProgram.navigateTo({
                url: `/packages/saas/login/index?redirectUrl=${redirectUrl}`,
              })
            } else {
              shouldShowWechatEnvToast = false
              Toast.show('需在微信App环境打开')
            }
          })
          setTimeout(() => {
            if (shouldShowWechatEnvToast) {
              Toast.show('需在微信App环境打开')
            }
          }, 3000)
        },
      }
    // 广发银行app
    case 'cgbbank':
      return {
        hideNavBar() { },
        goBackWebview() { },
        hideLayoutNavBar: () => true,
        goToPay: (params: { orderNo }) => {
          // debugger
          // pay({
          //   orderNo: params.orderNo,
          //   payType: 'cgb_app'
          // })
          if (
            !!window.AlipayJSBridge &&
            typeof window?.AlipayJSBridge.call == 'function'
          ) {
            const { orderNo } = params
            pay({
              orderNo,
              payType: 'cgb_app',
            })
              .then((payRes) => {
                const { data = {} } = payRes
                window?.AlipayJSBridge.call('cgbPay', data, function (res) {
                  console.log("res.respCode: ", res.respCode)
                  if (res) {
                    if (res.respCode == '0000') {
                      goTo(`/result?orderNo=${orderNo}&status=success`)
                    } else if (res.respCode == '0001') {
                      goTo(`/result?orderNo=${orderNo}&status=cancel`)
                    } else {
                      goTo(`/result?orderNo=${orderNo}&status=fail`)
                    }
                  } else {
                    goTo(`/result?orderNo=${orderNo}&status=fail`)
                    alert(res.err_msg)
                  }
                })
              })
              .catch((e) => {
                Toast.show({
                  content: React.createElement('p', {
                    dangerouslySetInnerHTML: {
                      __html: e.msg || '服务繁忙，请稍后再试~',
                    },
                  }),
                })
              })
          } else {
            alert('没有AlipayJSBridge')
          }
        },
        disablePayListSelect: () => true,
      }
    case 'zfb_mp':
      return {
        hideNavBar() { },
        goBackWebview() { },
        hideLayoutNavBar: () => true,
        // 带上支付参数：跳转第三方支付thirdPay，经过收银台，最后由/miniprogramPay 中间页进行分发
        goToPayWithParams: (params: Record<string, any>) => {
          const query = Object.fromEntries(
            Object.entries(params || {}).map(([key, val]) => [
              key,
              String(val ?? ''),
            ]),
          )
          if (query.normalUrl) {
            query.antomUrl = query.normalUrl
          }
          const url = addParameters('/pages/pay/index', query)
          console.log('goTopayUrl:', url)
          if (window?.my && typeof window.my !== undefined) {
            window?.my?.navigateTo({
              url,
            })
          } else {
            console.log('my 变量不存在')
          }
        },
        disablePayListSelect: () => true,
      }
    // 青岛银行
    case 'qdbank':
      return {
        hideNavBar() { },
        goBackWebview() {
          try {
            if (window?.AlipayJSBridge) {
              window?.AlipayJSBridge.call('closeTo', {
                index: -1,
              }, () => { });
            }
          } catch (err) { }
        },
        hideLayoutNavBar: () => false,
      }
    case 'xm_bank':
      return {
        hideNavBar() { },
        goBackWebview() {
          // alert('xm_bank 关闭web容器')
          window.location.href = 'http://xibls/mobileui/close'
        },
        hideLayoutNavBar: () => false,
      }
    // 泉州银行
    case 'quanZhouBank':
      return {
        hideNavBar() { },
        goBackWebview() {
          console.log('点击关闭web容器');
          sendNativeCmd('ltCloseWebView', {}, (response) => {
            console.log('响应(关闭容器指令实际无回调):', response);
          });
        },
        hideLayoutNavBar: () => false,
      }
    default:
      return {
        hideNavBar() { },
        goBackWebview() {
          goTo(-1)
        },
        hideLayoutNavBar: () => false,
        goToPay: (params: Record<string, any>) => {
          window?.wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/dpPay/dpPay?orderNo=${params.orderNo}`,
              })
            }
          })
        },
        disablePayListSelect: () => false,
        downloadPdf(downloadPdf: string, previewUrl: string) {
          window.open(downloadPdf, '__blank')
        },
      }
  }
  // ... 更多项目待补充
}

/**
 * @desc 后退页面失败处理
 * @param goBack 回退函数
 * @param fallback 回退失败兜底函数
 */
export function historyBackWFallback(goBack: () => void, fallback: () => void) {
  const prevPage = window.location.href
  goBack()
  setTimeout(function () {
    if (window.location.href == prevPage) {
      console.log('historyBack fallback')
      return fallback && fallback()
    }
    console.log('no fallback')
  }, 500)
}

// 即将废弃
export function getMiniProgramChannelApi(channel: string):
  | {
    goToOrderList?: () => void
    goToPay?: (params: Record<string, any>) => void
    goToPayResult?: (params: Record<string, any>) => void
    goToCodeExchangeSucceed?: () => void
    goToLogin?: (params: Record<string, any>) => void
    disablePayListSelect?: boolean // 是否隐藏
  }
  | false {
  const wx = window?.wx || window?.proxy?.wx
  switch (channel) {
    case 'drt':
      return {
        goToOrderList: () => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.navigateTo({
                url: '/pages/orderList/orderList',
              })
            }
          })
        },
        goToPay: (params: Record<string, any>) => {
          window?.wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/pay/index/index?orderNo=${params.orderNo}`,
              })
            }
          })
        },
        goToPayResult: ({ status }) => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/pay/result/index?status=${status}`,
              })
            }
          })
        },
      }
    case 'plus':
      return {
        goToOrderList: () => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              window?.wx?.miniProgram.switchTab({
                url: '/pages/main/userOrder/userOrder',
              })
            }
          })
        },
        goToPay: (params: Record<string, any>) => {
          window?.wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/pay/index/index?orderNo=${params.orderNo}`,
              })
            }
          })
        },
        goToPayResult: ({ status }) => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/pay/result/index?status=${status}`,
              })
            }
          })
        },
        goToLogin: ({ redirectUrl }) => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/login/login?redirectType=h5&redirectUrl=${redirectUrl}`,
              })
            }
          })
        },
      }
    // 权益通小程序
    case 'qyt':
      return {
        goToOrderList: () => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              window?.wx?.miniProgram.switchTab({
                url: '/pages/main/userOrder/userOrder',
              })
            }
          })
        },
        goToPay: (params: Record<string, any>) => {
          window?.wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/pay/index/index?orderNo=${params.orderNo}`,
              })
            }
          })
        },
        goToPayResult: ({ status }) => {
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/pay/result/index?status=${status}`,
                success: () => {
                  return true
                },
                fail: () => {
                  return false
                },
              })
            } else {
              return false
            }
          })
        },
        // 兑换码兑换成功页
        goToCodeExchangeSucceed() {
          const tenantCode = getStorage('tenantCode') || ''
          wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/codeExchangeSucceed/codeExchangeSucceed?tenantCode=${tenantCode}`,
              })
            }
          })
        },
      }

    // 钉钉企服小程序
    case 'ding':
      return {
        goToOrderList: () => {
          try {
            window?.dd?.switchTab({
              url: '/pages/orderList/orderList',
            })
          } catch (error) {
            console.log(error)
          }
        },
        goToPay: (params: Record<string, any>) => {
          try {
            window?.dd.redirectTo({
              url: `/pages/pay/index/index?orderNo=${params.orderNo}`,
            })
          } catch (err) {
            console.log(err)
          }
        },
        goToPayResult: ({ status }) => {
          try {
            window?.dd.redirectTo({
              url: `/pages/pay/result/index?status=${status}`,
              success: () => {
                return true
              },
              fail: () => {
                return false
              },
            })
          } catch (err) {
            console.log(err)
          }
        },
      }
    // 广发银行app
    case 'cgbbank':
      return {
        goToPay: (params: { orderNo }) => {
          // debugger
          pay({
            orderNo: params.orderNo,
            payType: 'cgb_app',
          })
          if (
            !!window.AlipayJSBridge &&
            typeof window?.AlipayJSBridge.call == 'function'
          ) {
            const { orderNo } = params
            pay({
              orderNo,
              payType: 'cgb_app',
            }).then((payRes) => {
              const { data = {} } = payRes
              window?.AlipayJSBridge.call('cgbPay', data, function (res) {
                if (res) {
                  if (res.respCode == '0000') {
                    goTo(`/result?orderNo=${orderNo}&status=success`)
                  } else if (res.respCode == '0001') {
                    goTo(`/result?orderNo=${orderNo}&status=cancel`)
                  } else {
                    goTo(`/result?orderNo=${orderNo}&status=fail`)
                  }
                } else {
                  goTo(`/result?orderNo=${orderNo}&status=fail`)
                  alert(res.err_msg)
                }
              })
            })
          }
        },

        disablePayListSelect: true,
      }

    default:
      return {
        goToPay: (params: Record<string, any>) => {
          window?.wx?.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // Toast.show({ content: 'has miniprogram' })
              window?.wx?.miniProgram.redirectTo({
                url: `/pages/dpPay/dpPay?orderNo=${params.orderNo}`,
              })
            }
          })
        },
      }
  }
}
